/*
 * AppReducer (global)
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer'
import {
  LOAD_REPOS_SUCCESS,
  LOAD_REPOS,
  LOAD_REPOS_ERROR,
  LOAD_SIGNED_IN_USER,
  LOAD_SIGNED_IN_USER_SUCCESS,
  LOAD_SIGNED_IN_USER_ERROR,
} from './constants'

// The initial state of the App
export const initialState = {
  loading: false,
  error: false,
  currentUser: false,
  userData: {
    repositories: false,
  },
  signedInUser: false,
}

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case LOAD_REPOS:
        draft.loading = true
        draft.error = false
        draft.userData.repositories = false
        break

      case LOAD_REPOS_SUCCESS:
        draft.userData.repositories = action.repos
        draft.loading = false
        draft.currentUser = action.username
        break

      case LOAD_REPOS_ERROR:
        draft.error = action.error
        draft.loading = false
        break

      case LOAD_SIGNED_IN_USER:
        draft.loading = true
        draft.error = false
        draft.signedInUser = false
        break

      case LOAD_SIGNED_IN_USER_SUCCESS:
        draft.userData.repositories = action.repos
        draft.loading = false
        draft.signedInUser = action.signedInUser
        break

      case LOAD_SIGNED_IN_USER_ERROR:
        draft.error = action.error
        draft.loading = false
        break
    }
  })

export default appReducer
